export default __webpack_public_path__ + "static/media/Boots of the Great Impi.bbee57f8.jpg";